import _objectSpread from "/builds/huggg/sangria/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { prop, propOr } from 'ramda';
import { translateObject } from '@huggg/bar-staff';
import { urls } from './../config.js';
import { firstById, mapById } from './../utils/find';
import getParams from '../utils/getParams';
import withAxios from '../utils/with-axios';
import { brandMap, productMap, superhugggMap, userMap } from '../translationMaps';
var DEFAULT_EMBED = ['sender', 'purchase', 'purchase.brand'];
var reformatSuperhuggg = function reformatSuperhuggg(_ref) {
  var huggg = _ref.data,
    embedded = _ref.embedded;
  var translatedSuperhuggg = translateObject(superhugggMap, huggg);
  var extract = function extract(id) {
    return propOr([], id, embedded);
  };
  var maybeRawPurchase = firstById(extract('products'), prop('purchaseId', translatedSuperhuggg));
  var purchase = maybeRawPurchase ? translateObject(productMap, maybeRawPurchase) : null;
  var maybeRawSender = firstById(extract('users'), prop('senderId', translatedSuperhuggg));
  var sender = maybeRawSender ? translateObject(userMap, firstById(extract('users'), prop('senderId', translatedSuperhuggg))) : null;
  if (purchase) {
    purchase.brand = translateObject(brandMap, firstById(extract('brands'), prop('brandId', purchase)));
    if (embedded.stores && embedded.stores.length) {
      purchase.brand.locations = mapById(propOr([], 'stores', embedded), propOr([], 'stores', purchase.brand));
    }
  }
  return _objectSpread(_objectSpread({}, translatedSuperhuggg), {}, {
    purchase: purchase,
    sender: sender
  });
};

/**
 * Greasy hack for sangria! Once fixed to use camlecase like highball does,
 * delete this!
 * @param {*} param0
 */
var addEmbeds = function addEmbeds(_ref2) {
  var huggg = _ref2.data,
    embedded = _ref2.embedded;
  var extract = function extract(id) {
    return propOr([], id, embedded);
  };
  var purchase = firstById(extract('products'), prop('purchase_id', huggg));
  var sender = firstById(extract('users'), prop('sender_id', huggg));
  if (purchase) {
    purchase.brand = firstById(extract('brands'), prop('brand_id', purchase));
    if (embedded.stores && embedded.stores.length) {
      purchase.brand.locations = mapById(propOr([], 'stores', embedded), propOr([], 'stores', purchase.brand));
    }
  }
  return _objectSpread(_objectSpread({}, huggg), {}, {
    purchase: purchase,
    sender: sender
  });
};
function single(axios, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultParams = {
    embed: DEFAULT_EMBED,
    is_preview: false
  };
  var useCamelCase = !options.disableFormatting;
  delete options.disableFormatting;
  var params = getParams(options, defaultParams);
  return axios.get(urls.apiV2("/super-hugggs/".concat(id)), {
    params: _objectSpread(_objectSpread({}, params), {}, {
      platform: 'app'
    })
  }).then(prop('data')).then(function (response) {
    return (
      // If we're in a new platform, we translate to camelcase AND add embeds
      useCamelCase ? reformatSuperhuggg(response) : addEmbeds(response)
    );
  });
}
var stash = function stash(axios, shortcode) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    phoneNumber = _ref3.phoneNumber,
    email = _ref3.email;
  return axios.post(urls.apiV2("/super-hugggs/".concat(shortcode, "/hugggs")), {
    phone_number: phoneNumber,
    email: email
  }).then(prop('data'));
};

/**
 * `single(id, [embed])` makes a request for a single, specific superhuggg by
 * ID or shortcode. If embed is not specified defaults will be used to return a
 * full result. *
 *
 * `stash(shortcode, { [phoneNumber]: string, [email]: string })` makes a request to generate a huggg for a
 * user from a super huggg. If the user is logged in then no phone number or email need
 * be provided, the generated huggg will be pre-stashed for that user. If it is
 * a client stashing the huggg then a phone number or email must be provided to link the
 * new huggg to a user. If the huggg is being stashed directly by a logged in
 * user it will be returned. However if the huggg is being stashed on behalf of
 * the user, they will be notified out-of-band and a 201 response will be
 * received from the API.
 *
 * ---
 *
 * NOTE: A "full result" may vary depending on the client applications level of
 * permission, and the currently logged in users level of permission.
 *
 * NOTE: The 1st param in both method sigs are `axios`. This should typically be
 * disregarded, the withAxios helper will inject that into the first position if
 * not provided.
 */
export default {
  single: withAxios(single),
  stash: withAxios(stash)
};